import { formatMoney, randomUUID } from '@betterment/core';

import { BillingPlanFlowValues, FeeConfigType, isExistingPlanWithClients } from './data';

import { BillingRate, SingleBillingRate } from '../../../graphql/schema';

const determineFeeConfigType = (billingRate: SingleBillingRate): FeeConfigType => {
  if (billingRate.__typename === 'BillingRateAssetBased') {
    return 'assetBasedConfiguration';
  }
  if (billingRate.__typename === 'BillingRateFixed') {
    return 'fixedConfiguration';
  }
  throw new Error('Unsupported billing rate type');
};

export const deconstructBillingRate = (billingRate: BillingRate) => {
  switch (billingRate.__typename) {
    case 'BillingRateFixed':
      return {
        fixedFeeAmount: formatMoney(billingRate.feeCents, 'raw'),
        assetBasedFeeRate: '',
        tiers: [
          {
            uuid: randomUUID(),
            firmFee: {
              feeConfigType: 'assetBasedConfiguration',
              feeValue: '',
            },
            tierEnd: '',
          },
          {
            uuid: randomUUID(),
            firmFee: {
              feeConfigType: 'assetBasedConfiguration',
              feeValue: '',
            },
            tierEnd: undefined,
          },
        ],
      };
    case 'BillingRateAssetBased':
      return {
        fixedFeeAmount: '',
        assetBasedFeeRate: `${billingRate.feeBps}`,
        tiers: [
          {
            uuid: randomUUID(),
            firmFee: {
              feeConfigType: 'assetBasedConfiguration',
              feeValue: '',
            },
            tierEnd: '',
          },
          {
            uuid: randomUUID(),
            firmFee: {
              feeConfigType: 'assetBasedConfiguration',
              feeValue: '',
            },
            tierEnd: undefined,
          },
        ],
      };
    case 'BillingRateTiered':
      return {
        fixedFeeAmount: '',
        assetBasedFeeRate: '',
        tiers: billingRate.tiers.map(tier => ({
          uuid: randomUUID(),
          firmFee: {
            feeConfigType: determineFeeConfigType(tier.firmFee),
            feeValue:
              tier.firmFee.__typename === 'BillingRateAssetBased'
                ? `${tier.firmFee.feeBps}`
                : formatMoney(tier.firmFee.feeCents, 'raw'),
          },
          tierEnd: tier.tierEnd ? formatMoney(tier.tierEnd, 'raw') : undefined,
        })),
        tieredFeeCalculationMethod: billingRate.calculationMethod,
      };
    default:
      throw new Error('Unsupported billing rate type');
  }
};

export const getFlowTitle = (flowValues: BillingPlanFlowValues, currentStep: number): string => {
  const totalSteps = isExistingPlanWithClients(flowValues) ? 3 : 2;
  if (flowValues.billingPlanId) {
    return `Edit billing plan | ${currentStep} of ${totalSteps}`;
  }
  return `Create billing plan | ${currentStep} of ${totalSteps}`;
};
